<template>
  <div></div>
</template>

<script>
export default {
  name: "TalentDev"
}
</script>

<style scoped>

</style>